module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "__form-extended",
    attrs: {
      "action": _vm.action
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.list), function(field) {
    return [(field.type === "hidden") ? _c('input', {
      attrs: {
        "type": field.type,
        "name": field.code
      },
      domProps: {
        "value": _vm.values[field.code]
      }
    }) : _c('div', {
      staticClass: "element"
    }, [_c(("element-" + (field.type)), {
      tag: "component",
      staticClass: "control",
      attrs: {
        "auto-width": true,
        "large": false,
        "filterable": field.filterable,
        "placeholder": field.placeholder || field.title,
        "multiple": field.multiple,
        "name": field.code,
        "options": field.options ? field.options : undefined,
        "value": _vm.values[field.code]
      },
      on: {
        "input": function($event) {
          return _vm.change(field.code, $event)
        }
      }
    })], 1)]
  }), _c('div', {
    staticClass: "element"
  }, [_c('button-default', {
    attrs: {
      "styleParams": _vm.styleParams,
      "wide": true,
      "factor": 1.35,
      "color": "filter"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83e1763c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/form/Filter.vue
// module id = 6f022e57b510c3e1f0a0
// module chunks = 0